// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PharmacyCardFinderV2PatientRequest } from './pharmacyCardFinderV2PatientRequest.js';
import type { PharmacyCardFinderV2Prescriber } from './pharmacyCardFinderV2Prescriber.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PharmacyCardFinderV2InputRequestModel {
    'patient': PharmacyCardFinderV2PatientRequest | null;
    'prescriber'?: PharmacyCardFinderV2Prescriber | null;
    'daysSupply'?: string;
    'ndc': string;
    'pharmacyNcpDpId'?: string;
    'pharmacyNpi': string;
    'project'?: string;
    'quantity'?: string;
    'clientId1'?: string;
    'clientId2'?: string;
    'clientWhiteListId'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PharmacyCardFinderV2InputRequestModel>> = [
        {
            "name":     "patient",
            "baseName": "patient",
            "type":     "PharmacyCardFinderV2PatientRequest"
        },
        {
            "name":     "prescriber",
            "baseName": "prescriber",
            "type":     "PharmacyCardFinderV2Prescriber"
        },
        {
            "name":     "daysSupply",
            "baseName": "daysSupply",
            "type":     "string"
        },
        {
            "name":     "ndc",
            "baseName": "ndc",
            "type":     "string"
        },
        {
            "name":     "pharmacyNcpDpId",
            "baseName": "pharmacyNcpDpId",
            "type":     "string"
        },
        {
            "name":     "pharmacyNpi",
            "baseName": "pharmacyNpi",
            "type":     "string"
        },
        {
            "name":     "project",
            "baseName": "project",
            "type":     "string"
        },
        {
            "name":     "quantity",
            "baseName": "quantity",
            "type":     "string"
        },
        {
            "name":     "clientId1",
            "baseName": "clientId1",
            "type":     "string"
        },
        {
            "name":     "clientId2",
            "baseName": "clientId2",
            "type":     "string"
        },
        {
            "name":     "clientWhiteListId",
            "baseName": "clientWhiteListId",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return PharmacyCardFinderV2InputRequestModel.attributeTypeMap;
    }
}
